import { createPopupStore } from './createPopupStore';

export type UpgradeSubscriptionPopupPayload = {
  retry?: () => void;
};

export const useUpgradeSubscriptionPopup = createPopupStore<UpgradeSubscriptionPopupPayload>();
